import {
  Configuration,
  DropdownOption,
  StatusDefinition,
} from "product-test-types";
import {
  findDropdownOption,
  getDropdownOptionColor,
  getDropdownOptionName,
  getDropdownOptionStoredValue,
} from "product-test-utils";

type DropdownLike = DropdownOption | StatusDefinition;

export const toDropdownItems = (options: DropdownLike[] | undefined) =>
  options?.map((option) => ({
    value: option.name ?? getDropdownOptionStoredValue(option) ?? "",
    label: option.name,
    color: option.color,
  })) ?? [];

export const getDropdownLabel = (
  options: DropdownLike[] | undefined,
  value: string | undefined | null
) => getDropdownOptionName(options, value) ?? value ?? "";

export const getDropdownColorValue = (
  options: DropdownLike[] | undefined,
  value: string | undefined | null,
  fallback: string
) => getDropdownOptionColor(options, value) ?? fallback;

export const getDropdownCount = (
  counts: Record<string, number> | undefined,
  option: DropdownLike
) =>
  counts?.[getDropdownOptionStoredValue(option) ?? ""] ??
  counts?.[option.name ?? ""] ??
  0;

export const getStreetlightStatusValue = (
  option:
    | {
        color?: string;
        order?: number;
      }
    | undefined
    | null
): "green" | "yellow" | "red" | undefined => {
  const normalizedColor = option?.color?.trim().toLowerCase();

  if (
    normalizedColor === "green" ||
    normalizedColor === "#00c853" ||
    normalizedColor === "#4caf50"
  ) {
    return "green";
  }

  if (
    normalizedColor === "yellow" ||
    normalizedColor === "orange" ||
    normalizedColor === "#f89500" ||
    normalizedColor === "#ffb74d"
  ) {
    return "yellow";
  }

  if (
    normalizedColor === "red" ||
    normalizedColor === "#ff0000" ||
    normalizedColor === "#f44336"
  ) {
    return "red";
  }

  if (option?.order === 0) {
    return "green";
  }

  if (option?.order === 1) {
    return "yellow";
  }

  if (option?.order === 2) {
    return "red";
  }

  return undefined;
};

export const findOption = (
  options: DropdownLike[] | undefined,
  value: string | undefined | null
) => findDropdownOption(options, value);

export const getSemaphoreStatusOptions = (
  configuration: Configuration | undefined
): DropdownLike[] => {
  if ((configuration?.statusDefinition?.length ?? 0) >= 3) {
    return configuration?.statusDefinition?.slice(0, 3) ?? [];
  }

  return [
    configuration?.semaphoreStatusDefinition?.[0]?.low,
    configuration?.semaphoreStatusDefinition?.[0]?.medium,
    configuration?.semaphoreStatusDefinition?.[0]?.high,
  ].filter(Boolean) as DropdownLike[];
};
